export default __webpack_public_path__ + "static/media/ic_transnistria.fd37b73b.svg";